import {httpPost} from "../utils/httpHelper";

const API_URL = process.env.REACT_APP_API_URL;

export const getAllArticles = (data) => {
    return httpPost('/service/simplicityService/knowledgeBank/articles/all', data,true)
        .then((res) => {
            return res;
        })
};

export const getAllEvents = (data) => {
    return httpPost('/service/simplicityService/knowledgeBank/events/all', data, true)
        .then((res) => {
            return res;
        })
};

export const getAllPublications = (data) => {
    return httpPost('/service/simplicityService/knowledgeBank/publications/all', data, true)
        .then((res) => {
            return res;
        })
};
